import api from './../api.js';

export default {
    created(){
        const vm = this;
        
        vm.canDelete = false;
        vm.canWrite = false;

        api.validateDeletePermission().then(
            (canDelete) => vm.canDelete = canDelete,
            (canDelete) => vm.canDelete = canDelete
        );

        api.validateWritePermission().then(
            (canWrite) => vm.canWrite = canWrite,
            (canWrite) => vm.canWrite = canWrite
        );
    },
    data: () => ({
        canDelete: false,
        canWrite: false
    })
}